import { Text, View } from "@react-pdf/renderer";
import { transportationDocumentStyles } from "../transportationDocument/transportationDocumentStyles";
import { defaultTheme } from "../../../../theme/theme";

const {
    transportationDocumentLocationsData,
} = transportationDocumentStyles();

// const mockDestinationsData = {
//     dataTransportationDocumentLocations: [
//         {
//             location_type: 'Destino',
//             rfc: 'XAXX010101000',
//             business_name: 'EMPRESA DESTINO S.A. DE C.V.',
//             country_name: 'México',
//             state_name: 'Jalisco',
//             city_name: 'Guadalajara',
//             street: 'Av. Vallarta 1234',
//             postal_code: '44100',
//             date_hour_departure_arrival: '2023-05-15 14:30',
//             distance: '350 km'
//         },
//         {
//             location_type: 'Destino',
//             rfc: 'XEXX010101000',
//             business_name: 'DISTRIBUIDORA CENTRAL',
//             country_name: 'México',
//             state_name: 'Ciudad de México',
//             city_name: 'Alcaldía Cuauhtémoc',
//             street: 'Paseo de la Reforma 505',
//             postal_code: '06500',
//             date_hour_departure_arrival: '2023-05-16 10:15',
//             distance: '420 km'
//         },
//         {
//             location_type: 'Destino',
//             rfc: 'XEXX010101000',
//             business_name: 'DISTRIBUIDORA CENTRAL',
//             country_name: 'México',
//             state_name: 'Ciudad de México',
//             city_name: 'Alcaldía Cuauhtémoc',
//             street: 'Paseo de la Reforma 505',
//             postal_code: '06500',
//             date_hour_departure_arrival: '2023-05-16 10:15',
//             distance: '420 km'
//         },,
//         {
//             location_type: 'Destino',
//             rfc: 'XEXX010101000',
//             business_name: 'DISTRIBUIDORA CENTRAL',
//             country_name: 'México',
//             state_name: 'Ciudad de México',
//             city_name: 'Alcaldía Cuauhtémoc',
//             street: 'Paseo de la Reforma 505',
//             postal_code: '06500',
//             date_hour_departure_arrival: '2023-05-16 10:15',
//             distance: '420 km'
//         },,
//         {
//             location_type: 'Destino',
//             rfc: 'XEXX010101000',
//             business_name: 'DISTRIBUIDORA CENTRAL',
//             country_name: 'México',
//             state_name: 'Ciudad de México',
//             city_name: 'Alcaldía Cuauhtémoc',
//             street: 'Paseo de la Reforma 505',
//             postal_code: '06500',
//             date_hour_departure_arrival: '2023-05-16 10:15',
//             distance: '420 km'
//         },,
//         {
//             location_type: 'Destino',
//             rfc: 'XEXX010101000',
//             business_name: 'DISTRIBUIDORA CENTRAL',
//             country_name: 'México',
//             state_name: 'Ciudad de México',
//             city_name: 'Alcaldía Cuauhtémoc',
//             street: 'Paseo de la Reforma 505',
//             postal_code: '06500',
//             date_hour_departure_arrival: '2023-05-16 10:15',
//             distance: '420 km'
//         }
//     ],
//     dataInvoiceGeneral: {
//         // otros datos necesarios...
//     }
// };


export const Destinations = ({ data, showTranslatedText }: any) => {

    let primaryColor = defaultTheme.palette.primary.main

    return (
        <View style={transportationDocumentLocationsData.container} fixed>
            <View style={[transportationDocumentLocationsData.titleContainer, {backgroundColor: primaryColor}]} >
                <Text style={[transportationDocumentLocationsData.title,{color: 'white'}]}>{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.SENTTO(DESTINATIONS)")}</Text>
            </View>
            <View style={transportationDocumentLocationsData.tableContainer} >
                <View style={transportationDocumentLocationsData.titleRow} >
                    <Text style={transportationDocumentLocationsData.firstConceptField} ></Text>
                    <Text style={transportationDocumentLocationsData.rfcConcept} >RFC</Text>
                    <Text style={transportationDocumentLocationsData.businessNameConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.businessName")}</Text>
                    <Text style={transportationDocumentLocationsData.countryConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.country")}</Text>
                    <Text style={transportationDocumentLocationsData.stateConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.state")}</Text>
                    <Text style={transportationDocumentLocationsData.cityConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.city")}</Text>
                    <Text style={transportationDocumentLocationsData.addressConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.street")}</Text>
                    <Text style={transportationDocumentLocationsData.postalCodeConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.postalCode")}</Text>
                    <Text style={transportationDocumentLocationsData.dateConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.date")}</Text>
                    <Text style={transportationDocumentLocationsData.distanceConcept} >{showTranslatedText("reports.salesInvoicePdf.transportationDocumentLocationsData.distance")}</Text>
                </View>
                {data.dataTransportationDocumentLocations.map((item: any, index: any) => {
                    if (item.location_type == 'Destino') {
                        return (
                            <View style={transportationDocumentLocationsData.row} key={index} wrap={false}>
                                <Text style={transportationDocumentLocationsData.firstDataField} >{item.location_type || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.rfcData} >{item.rfc || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.businessNameData} >{item.business_name || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.countryData} >{item.country_name || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.stateData} >{item.state_name || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.cityData} >{item.city_name || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.addressData} >{item.street || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.postalCodeData} >{item.postal_code || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.dateData} >{item.date_hour_departure_arrival || ' '}</Text>
                                <Text style={transportationDocumentLocationsData.distanceData} >{item.distance || ' '}</Text>
                            </View>
                        );
                    }
                })
                }
            </View>
        </View>
    )
}